import { clauseCheckDocStatus } from "../../modules/vscDashboard/constants";
import StatusPillStyles from "./StatusPill.module.scss";

export const StatusPill = ({ status, message }: any) => {
  const getStyle = () => {
    switch (status) {
      case clauseCheckDocStatus.UPLOAD_IN_PROGRESS:
        return { text: "Uploading", style: StatusPillStyles.uploadInProgress };
      case clauseCheckDocStatus.UPLOAD_COMPLETED:
        return { text: "Uploaded", style: StatusPillStyles.uploadCompleted };
      case clauseCheckDocStatus.CLAUSE_CHECK_READY:
      case clauseCheckDocStatus.CLAUSE_CHECK_COMPLETED:
        return { text: "Reviewed", style: StatusPillStyles.completed };
      default:
        return { text: "Reviewing", style: StatusPillStyles.inProgress };
    }
  };
  const { text, style } = getStyle();
  return <span className={style}>{text}</span>;
};
